/**
 * Promo
 */
import { isOnPage, loadPost } from './utils';

if (isOnPage('.promo__link')) {
  const serviceEndpoint = `${window.location.origin}/wp-json/motion/v1/promo/`;

  Array.from(document.querySelectorAll('.promo__link')).forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      loadPost(btn, serviceEndpoint);
    });
  });
}
